import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-541be269"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "right-sidebar",
  tabindex: "1",
  style: {"overflow":"auto","z-index":"1!important"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"80px"} }, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card-body dashboard-card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 pl-2 h-100 pr-15" }
const _hoisted_8 = { class: "m-0 p-0 font-size-13 float-right dash-ac-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  class: "m-0 p-0 font-size-16 float-right dash-ac-balance",
  style: {}
}
const _hoisted_11 = { id: "paymaster_balance" }
const _hoisted_12 = {
  key: 0,
  class: "col-12 p-0",
  id: "paymaster_chartBody"
}
const _hoisted_13 = {
  id: "chart",
  style: {"height":"80px"}
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "row right-side-total" }
const _hoisted_16 = { class: "col-6 pr-0" }
const _hoisted_17 = {
  class: "font-size-13 font-grey",
  id: "total_balance"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 p-0 text-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-size-13 font-grey" }, "Total Portfolio")
], -1))
const _hoisted_19 = { class: "main-content" }
const _hoisted_20 = { class: "section" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-4 col-sm-12 text-left d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "mr-4",
      src: "https://map.admin.caprock.com.au/inlancer-admin/images/dashboard.svg",
      style: {"height":"18px"}
    }),
    /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Dashboard")
    ])
  ])
], -1))
const _hoisted_23 = { class: "col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center align-items-center" }
const _hoisted_24 = {
  class: "nav nav-pills dashboard-nav mb-3",
  id: "pills-tab",
  role: "tablist"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link active",
  id: "v-pills-home-tab",
  "data-toggle": "pill",
  href: "#",
  role: "tab",
  "aria-controls": "v-pills-home",
  "aria-selected": "true"
}, "Overview", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  id: "v-pills-profile-tab",
  "data-toggle": "pill",
  href: "#",
  role: "tab",
  "aria-controls": "v-pills-profile",
  "aria-selected": "false"
}, "Currencies", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-4 col-sm-12 text-right" }, null, -1))
const _hoisted_30 = { class: "tab-content w-100" }
const _hoisted_31 = {
  class: "tab-pane fade show active",
  id: "v-pills-home",
  role: "tabpanel",
  "aria-labelledby": "v-pills-home-tab"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  key: 0,
  class: "col-6"
}
const _hoisted_34 = { class: "row h-100" }
const _hoisted_35 = { class: "col-6 my-4" }
const _hoisted_36 = { class: "p-4 bg-white border-radius-10 card text-center" }
const _hoisted_37 = { class: "font-size-15" }
const _hoisted_38 = { id: "this_month_name" }
const _hoisted_39 = {
  class: "dash-card-total mb-3",
  id: "this_month_deposit"
}
const _hoisted_40 = { class: "font-size-15 mb-2" }
const _hoisted_41 = { id: "previous_month_deposit" }
const _hoisted_42 = { class: "col-6 my-4" }
const _hoisted_43 = { class: "p-4 bg-white border-radius-10 card text-center" }
const _hoisted_44 = { class: "font-size-15" }
const _hoisted_45 = { id: "this_month_name" }
const _hoisted_46 = {
  class: "dash-card-total mb-3",
  id: "this_month_withdrawl"
}
const _hoisted_47 = { class: "font-size-15 mb-2" }
const _hoisted_48 = { id: "previous_month_withdrawl" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "p-4 bg-white border-radius-10 h-100" }
const _hoisted_51 = { class: "dash-map-title p-0" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-5 mt-3" }
const _hoisted_54 = { class: "p-2" }
const _hoisted_55 = { class: "dash-card-total" }
const _hoisted_56 = {
  key: 0,
  width: "15pt",
  height: "15pt",
  version: "1.1",
  viewBox: "0 0 752 752",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { fill: "red" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m197.46 428.57 167.18 167.18c6.6289 6.6289 17.051 6.6289 23.207 0l167.18-167.18c6.6289-6.6289 6.6289-17.051 0-23.207l-17.996-17.996c-6.6289-6.6289-17.051-6.6289-23.207 0l-107.5 107.5v-327.25c0-8.9961-7.5781-16.574-16.574-16.574h-25.102c-8.9961 0-16.574 7.5781-16.574 16.574v329.61l-109.87-109.87c-6.6289-6.6289-17.051-6.6289-23.207 0l-17.996 17.996c-6.1562 6.6289-6.1562 17.051 0.47266 23.207z" })
], -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  width: "15pt",
  height: "15pt",
  version: "1.1",
  viewBox: "0 0 752 752",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { fill: "#05b171" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m555.02 323.43-167.18-167.18c-6.6289-6.6289-17.051-6.6289-23.207 0l-167.18 167.18c-6.6289 6.6289-6.6289 17.051 0 23.207l17.996 17.996c6.6289 6.6289 17.051 6.6289 23.207 0l107.5-107.5v327.72c0 8.9961 7.5781 16.574 16.574 16.574h25.102c8.9961 0 16.574-7.5781 16.574-16.574v-329.61l109.87 109.87c6.6289 6.6289 17.051 6.6289 23.207 0l17.996-17.996c6.1562-7.1055 6.1562-17.523-0.47266-23.68z" })
], -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "%", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-size-15" }, "Active Accounts", -1))
const _hoisted_64 = { class: "col-7 mt-3" }
const _hoisted_65 = { class: "p-2" }
const _hoisted_66 = { class: "dash-card-total" }
const _hoisted_67 = {
  key: 0,
  width: "15pt",
  height: "15pt",
  version: "1.1",
  viewBox: "0 0 752 752",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { fill: "red" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m197.46 428.57 167.18 167.18c6.6289 6.6289 17.051 6.6289 23.207 0l167.18-167.18c6.6289-6.6289 6.6289-17.051 0-23.207l-17.996-17.996c-6.6289-6.6289-17.051-6.6289-23.207 0l-107.5 107.5v-327.25c0-8.9961-7.5781-16.574-16.574-16.574h-25.102c-8.9961 0-16.574 7.5781-16.574 16.574v329.61l-109.87-109.87c-6.6289-6.6289-17.051-6.6289-23.207 0l-17.996 17.996c-6.1562 6.6289-6.1562 17.051 0.47266 23.207z" })
], -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 1,
  width: "15pt",
  height: "15pt",
  version: "1.1",
  viewBox: "0 0 752 752",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { fill: "#05b171" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m555.02 323.43-167.18-167.18c-6.6289-6.6289-17.051-6.6289-23.207 0l-167.18 167.18c-6.6289 6.6289-6.6289 17.051 0 23.207l17.996 17.996c6.6289 6.6289 17.051 6.6289 23.207 0l107.5-107.5v327.72c0 8.9961 7.5781 16.574 16.574 16.574h25.102c8.9961 0 16.574-7.5781 16.574-16.574v-329.61l109.87 109.87c6.6289 6.6289 17.051 6.6289 23.207 0l17.996-17.996c6.1562-7.1055 6.1562-17.523-0.47266-23.68z" })
], -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "%", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-size-15" }, "Portfolio", -1))
const _hoisted_75 = { class: "col-12 mt-3" }
const _hoisted_76 = { id: "year-balance-chart" }
const _hoisted_77 = {
  key: 1,
  class: "col-12"
}
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-541be269><div class=\"col-12\" data-v-541be269><div class=\"p-4 bg-white border-radius-10 text-left\" data-v-541be269><div style=\"width:auto;padding:70px 0;text-align:center;\" data-v-541be269><p class=\"font-grey text-center\" data-v-541be269>Loading ... !!</p></div></div></div></div>", 1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = {
  key: 2,
  class: "col-6"
}
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-12 mt-4" }
const _hoisted_83 = { class: "p-4 bg-white border-radius-10 text-left" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dash-map-title font-size-14" }, " Investment menu ", -1))
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "col-7" }
const _hoisted_87 = { style: {"color":"#4D5E80","font-size":"14px"} }
const _hoisted_88 = {
  key: 0,
  style: {"font-weight":"bold","padding-left":"3px","color":"#4D5E80 !important","font-size":"13px"}
}
const _hoisted_89 = {
  key: 1,
  style: {"font-weight":"bold","padding-left":"3px","color":"#4D5E80 !important","font-size":"13px"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#4D5E80","font-size":"14px"} }, " Min Investment ")
], -1))
const _hoisted_91 = { class: "col-2" }
const _hoisted_92 = { style: {"font-weight":"bold","color":"#4D5E80","font-size":"14px"} }
const _hoisted_93 = { class: "col-4" }
const _hoisted_94 = { style: {"font-weight":"bold","color":"#4D5E80 !important","font-size":"13px"} }
const _hoisted_95 = { class: "col-3" }
const _hoisted_96 = {
  key: 0,
  style: {"color":"#4D5E80 !important","font-size":"13px","border":"1px solid #e6e6e6","padding":"1px 7px","border-radius":"2px"}
}
const _hoisted_97 = { class: "col-3" }
const _hoisted_98 = { style: {"color":"#4D5E80 !important","font-size":"13px","border":"1px solid #e6e6e6","padding":"1px 2px","border-radius":"2px"} }
const _hoisted_99 = { class: "col-2" }
const _hoisted_100 = {
  key: 0,
  id: "alert_list",
  style: {"width":"auto","height":"320px"}
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-grey text-center" }, "No records found !!", -1))
const _hoisted_102 = [
  _hoisted_101
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"pointer-events":"none"},
                class: "dashboard-card bg-light mb-0",
                key: ac.userac_id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(ac.ac_name), 1),
                      _hoisted_9,
                      _createElementVNode("p", _hoisted_10, [
                        _createElementVNode("b", _hoisted_11, "$" + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                      ])
                    ]),
                    (ac.default_currency_balance>0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_apexchart, {
                              type: "area",
                              height: "100",
                              options: ac.chartOptions,
                              series: ac.series
                            }, null, 8, ["options", "series"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, "$" + _toDisplayString(_ctx.total_ac_balance), 1)
              ]),
              _hoisted_18
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("ul", _hoisted_24, [
              _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
                class: "nav-item nav-start-tab"
              }, _hoisted_26),
              _createElementVNode("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/currency'))),
                class: "nav-item nav-end-tab"
              }, _hoisted_28)
            ])
          ]),
          _hoisted_29
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_ctx.customer_accounts.length>0 && _ctx.loading==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("p", _hoisted_37, [
                            _createTextVNode(" Total Deposit: "),
                            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.this_month), 1)
                          ]),
                          _createElementVNode("h4", _hoisted_39, " $" + _toDisplayString(_ctx.dashboard.deposit_curr_month), 1),
                          _createElementVNode("p", _hoisted_40, [
                            _createTextVNode(_toDisplayString(_ctx.prev_month) + " : ", 1),
                            _createElementVNode("span", _hoisted_41, " $" + _toDisplayString(_ctx.dashboard.deposit_prev_month), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("p", _hoisted_44, [
                            _createTextVNode(" Total Withdrawl: "),
                            _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.this_month), 1)
                          ]),
                          _createElementVNode("h4", _hoisted_46, " $" + _toDisplayString(_ctx.dashboard.withdrawl_curr_month), 1),
                          _createElementVNode("p", _hoisted_47, [
                            _createTextVNode(_toDisplayString(_ctx.prev_month) + " : ", 1),
                            _createElementVNode("span", _hoisted_48, " $" + _toDisplayString(_ctx.dashboard.withdrawl_prev_month), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.this_month), 1),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("h4", _hoisted_55, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.dashboard.active_accounts), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass([{'p-growth':_ctx.dashboard.account_growth>0},{'b-growth':_ctx.dashboard.account_growth==0},{'n-growth':_ctx.dashboard.account_growth<0}])
                                  }, [
                                    (_ctx.dashboard.account_growth<0)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_58))
                                      : _createCommentVNode("", true),
                                    (_ctx.dashboard.account_growth>0)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_59, _hoisted_61))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.dashboard.account_growth) + " ", 1),
                                    _hoisted_62
                                  ], 2)
                                ]),
                                _hoisted_63
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("h4", _hoisted_66, [
                                  _createElementVNode("span", null, " $" + _toDisplayString(_ctx.portfolio_balance), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass([{'p-growth':_ctx.dashboard.account_growth>0},{'b-growth':_ctx.dashboard.account_growth==0},{'n-growth':_ctx.dashboard.account_growth<0}])
                                  }, [
                                    (_ctx.dashboard.portfolio_growth<0)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_67, _hoisted_69))
                                      : _createCommentVNode("", true),
                                    (_ctx.dashboard.portfolio_growth>0)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_70, _hoisted_72))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.dashboard.portfolio_growth) + " ", 1),
                                    _hoisted_73
                                  ], 2)
                                ]),
                                _hoisted_74
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createVNode(_component_apexchart, {
                                  width: "100%",
                                  options: _ctx.chartOptions,
                                  series: _ctx.series
                                }, null, 8, ["options", "series"])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.customer_accounts.length==0 && _ctx.loading==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_79))
                : _createCommentVNode("", true),
              (_ctx.loading==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
                            return (_openBlock(), _createElementBlock("div", {
                              onClick: ($event: any) => (_ctx.$router.push(alert.alert_URL+alert.inv_id)),
                              key: alert.alert_id,
                              class: "row p-cursor",
                              style: {"border-bottom":"1px solid #e6e6e6","margin-bottom":"20px","padding-bottom":"5px"}
                            }, [
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("span", _hoisted_87, _toDisplayString(alert.inv_name) + " - " + _toDisplayString(alert.ms_type), 1),
                                (alert.inv_interest_rate)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, " ( Interest Rate - " + _toDisplayString(alert.inv_interest_rate) + " % ) ", 1))
                                  : _createCommentVNode("", true),
                                (alert.ms_risk_profile)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_89, " ( Risk Profile - " + _toDisplayString(alert.ms_risk_profile) + " ) ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_90,
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("span", _hoisted_92, _toDisplayString(alert.inv_ref_code), 1)
                              ]),
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("span", _hoisted_94, _toDisplayString(alert.inv_type), 1)
                              ]),
                              _createElementVNode("div", _hoisted_95, [
                                (alert.location)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(alert.location), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_97, [
                                _createElementVNode("span", _hoisted_98, _toDisplayString(alert.inv_amount) + " " + _toDisplayString(alert.currency), 1)
                              ]),
                              _createElementVNode("div", _hoisted_99, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(alert.inv_status=='Active'?'active_s':'pending_s'),
                                  style: {"font-size":"13px","border":"1px solid #e6e6e6","padding":"1px 7px","border-radius":"2px"}
                                }, _toDisplayString(alert.inv_status), 3)
                              ])
                            ], 8, _hoisted_85))
                          }), 128)),
                          (!_ctx.alerts.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, _hoisted_102))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}